const GetData = {
    // ApiUrl: "http://192.168.100.137/BnpApi/",
    ApiUrl: "https://localhost:5001/",

};
export default GetData;